import _ from 'lodash'

angular.module('clientDashboardApp').directive('requiresPermission', function(userService) {

  return {
    restrict: 'A',
    link: function(scope, element, attrs) {
      element.addClass('d-none')
      userService.currentUser().then(user => {
        const permissions = attrs.requiresPermission.split(",").map( permission => (permission.trim()))
        if (user.permissions.indexOf('GlobalAccess') !== -1 || _.intersection(user.permissions, permissions).length === permissions.length) {
          element.removeClass('d-none');
        }
      })
    }
  }

});
